import React from 'react';

const TextArea = ({ ariaLabel, name, type, placeholder, field, onChange, value }) => (
  <textarea
    {...field}
    aria-label={ariaLabel}
    onChange={onChange}
    value={value}
    name={name}
    type={type}
    className="appearance-none relative block w-full px-3 py-2 bg-blue-900 border border-blue-800 placeholder-gray-500 text-gray-200 rounded-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
    placeholder={placeholder}
  />
);

export default TextArea;
